import { BASE_DRIVER_COLUMNS } from '../TransportTableHeading/TransportTableHeading.tsx'
import LocalizedFileInput from 'components/Erp/LocalizedFileInput';
import { getLocale } from 'i18n';
import { tr } from 'i18n';
import VehicleNumberInput from 'components/Forms/VehicleNumberInput/VehicleNumberInput.tsx';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import { SectionHeading, EmptyState } from 'components/Erp/Presentation';
import React, { useState } from 'react'
import ResponsiveTable from './ResponsiveTable'
import { MapPin, Map , Building2, Plus, Network, UsersRound, Truck, Pencil, Save, X, ChevronLeft, ChevronRight, FileText } from 'lucide-react'
import AuditButton from './AuditButton'
import { useSelector } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { hasAccess, canViewDrivers } from 'utils/access'
import DriverActions from './DriverActions'
import BaseDriverSummary from './BaseDriverSummary'
import BaseDriverDetails from './BaseDriverDetails'
import list from './DriverBaseList.module.scss'
import OperatorPinResetAction from './OperatorPinResetAction'
import OperatorInnChangeAction from './OperatorInnChangeAction'
import ActorPinField from 'components/Erp/ActorPinField/ActorPinField.tsx'
import { DateTime, StatusBadge } from 'components/Erp/Display'
import styles from '../AdminPanelPage.module.scss'
import MiniMap from 'pages/ReportCard/MiniMap'
import BranchesList from './BranchesList'

const PrivatePointsPanel = ({
  privatePointsFilter,
  setPrivatePointsFilter,
  filteredPrivatePoints,
  privatePointsPagination,
  loadPrivatePointsPage,
  openCreateModal,
  startEdit,
  editingPrivatePoint,
  editPayloads,
  setEditPayloads,
  saveEdit,
  cancelEdit,
  expandedPrivatePoint,
  setExpandedPrivatePoint,
  expandedOperatorsPrivatePoint,
  setExpandedOperatorsPrivatePoint,
  expandedDriversPrivatePoint,
  setExpandedDriversPrivatePoint,
  expandedBranchesPrivatePoint,
  setExpandedBranchesPrivatePoint,
  loadOperatorsByPrivatePointPage,
  loadDriversByPrivatePointPage,
  loadBranchesByPrivatePointPage,
  operatorsByPrivatePoint,
  driversByPrivatePoint,
  branchesByPrivatePoint,
  operatorsPaginationByPrivatePoint,
  driversPaginationByPrivatePoint,
  branchesPaginationByPrivatePoint,
  operatorsFilterByPrivatePoint,
  driversFilterByPrivatePoint,
  branchesFilterByPrivatePoint,
  setOperatorsFilterByPrivatePoint,
  setDriversFilterByPrivatePoint,
  setBranchesFilterByPrivatePoint,
  employees,
  editingOperatorByPrivatePoint,
  editingDriverByPrivatePoint,
  editingBranchByPrivatePoint,
  startEditOperator,
  startEditDriver,
  startEditBranch,
  saveEditOperator,
  saveEditDriver,
  saveEditBranch,
  cancelEditOperator,
  cancelEditDriver,
  cancelEditBranch,loadOperators,
  loadDriversByPrivatePoint,
  expandedDriverByPrivatePoint,
  toggleDriver,
  expandedOperatorByPrivatePoint,
  toggleOperatorPrivatePoint,
  printDriverPass,
  downloadDriverPass,
  privatePoints,
  topBases = [],
  chpps = []
}) => {
  useInterfaceLanguage();
  const currentUser=useSelector(state=>state.user)
  const driversVisible = canViewDrivers(currentUser)
  const [visibleMaps, setVisibleMaps] = useState({})
  return (
    <div className={styles.panel}>
      <SectionHeading icon={Building2} title={tr("Социальные объекты и МСУ")} actions={<><div>
          <button className={styles.addButton} onClick={() => openCreateModal('privatepoint')}><Plus size={14} aria-hidden="true"/>{tr(" Добавить частную точку")}</button>
        </div></>} />
      <div className={styles.panelBody}>
        <div className={styles.searchRow}>
          <input className={styles.searchInput} placeholder={tr("Поиск...")} value={privatePointsFilter} onChange={(e) => setPrivatePointsFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadPrivatePointsPage(1, privatePointsFilter) }} />
        </div>
        {filteredPrivatePoints && filteredPrivatePoints.length ? (
          <ResponsiveTable className={styles.table}>
            <thead>
              <tr>
                <th>№</th>
                <th>{tr("Название")}</th>
                <th>{tr("Телефон")}</th>
                <th>{tr("Местоположение")}</th>
                <th>{tr("Действия")}</th>
              </tr>
            </thead>
            <tbody>
              {filteredPrivatePoints.map((pp, index) => (
                <React.Fragment key={pp.id}>
                  <tr className={styles.topBaseRow}>
                    <td>{tr(index + 1)}</td>
                    <td className={styles.topBaseTitle} onClick={() => { const newVal = (expandedPrivatePoint === pp.id ? null : pp.id); setExpandedPrivatePoint(newVal); if (newVal) loadOperatorsByPrivatePointPage(pp.id, 1); }}>{tr(pp.name)}</td>
                    <td>{tr(pp.phone || '-')}</td>
                    <td>
                      {pp.geo ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexDirection: 'column' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <button
                              onClick={() => window.open(`https://www.google.com/maps?q=${pp.geo}`, '_blank')}
                              className={styles.geoLinkBtn}
                              title={tr("Открыть в Google Maps")}
                            >
                              <Map size={13}/>{tr(" Карты")}</button>
                            <button
                              onClick={() => setVisibleMaps(previous => ({ ...previous, [pp.id]: !previous[pp.id] }))}
                              aria-expanded={!!visibleMaps[pp.id]}
                              aria-controls={`map-privatepoint-${pp.id}`}
                              className={styles.mapToggleBtn}
                              title={tr("Показать/скрыть карту")}
                            >
                              <MapPin size={13}/>
                            </button>
                          </div>
                          <div id={`map-privatepoint-${pp.id}`} style={{ width: 200, height: 150, display: visibleMaps[pp.id] ? 'block' : 'none' }}>
                            <MiniMap geo={pp.geo} />
                          </div>
                        </div>
                      ) : '-'}
                    </td>
                    <td>
                      <div className={styles.actionGroup}>
                        <button aria-expanded={expandedPrivatePoint === pp.id && expandedBranchesPrivatePoint === pp.id} className={`${styles.smallBtn} ${expandedPrivatePoint === pp.id && expandedBranchesPrivatePoint === pp.id ? styles.actionActive : ''}`} onClick={() => { const newVal = (expandedBranchesPrivatePoint === pp.id ? null : pp.id); setExpandedBranchesPrivatePoint(newVal); if (newVal) loadBranchesByPrivatePointPage(pp.id, 1); setExpandedPrivatePoint(pp.id); }}><Network size={14} aria-hidden="true"/>{tr(" Филиалы")}</button>
                        <button aria-expanded={expandedPrivatePoint === pp.id && expandedOperatorsPrivatePoint === pp.id} className={`${styles.smallBtn} ${expandedPrivatePoint === pp.id && expandedOperatorsPrivatePoint === pp.id ? styles.actionActive : ''}`} onClick={() => { const newVal = (expandedOperatorsPrivatePoint === pp.id ? null : pp.id); setExpandedOperatorsPrivatePoint(newVal); if (newVal) loadOperatorsByPrivatePointPage(pp.id, 1); setExpandedPrivatePoint(pp.id); }}><UsersRound size={14} aria-hidden="true"/>{tr(" Операторы")}</button>
                        {tr(driversVisible && <button aria-expanded={expandedPrivatePoint === pp.id && expandedDriversPrivatePoint === pp.id} className={`${styles.smallBtn} ${expandedPrivatePoint === pp.id && expandedDriversPrivatePoint === pp.id ? styles.actionActive : ''}`} onClick={() => { const newVal = (expandedDriversPrivatePoint === pp.id ? null : pp.id); setExpandedDriversPrivatePoint(newVal); if (newVal) loadDriversByPrivatePointPage(pp.id, 1); setExpandedPrivatePoint(pp.id); }}><Truck size={14} aria-hidden="true"/>{tr(" Водители")}</button>)}
                        <button className={`${styles.smallBtn} ${styles.editBtn}`} onClick={() => startEdit('privatepoint', pp.id, { name: pp.name, phone: pp.phone })}><Pencil size={14} aria-hidden="true"/>{tr(" Изменить")}</button><AuditButton section="private_points" objectId={pp.id} objectType="tabel.PrivatePoint"/>
                      </div>
                    </td>
                  </tr>
                  {tr(editingPrivatePoint === pp.id && (
                    <tr>
                      <td colSpan={5}>
                        <div style={{ padding: 8 }}>
                          <label>{tr("Название")}</label>
                          <input value={(editPayloads[`privatepoint__${pp.id}`] || {}).name || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`privatepoint__${pp.id}`]: { ...p[`privatepoint__${pp.id}`], name: e.target.value } }))} />
                          <label style={{ marginLeft: 8 }}>{tr("Телефон")}</label>
                          <input value={(editPayloads[`privatepoint__${pp.id}`] || {}).phone || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`privatepoint__${pp.id}`]: { ...p[`privatepoint__${pp.id}`], phone: e.target.value } }))} />
                          <div style={{ marginTop: 8 }} className={styles.navbattons}>
                            <button className={styles.btn_pin} onClick={() => saveEdit('privatepoint', pp.id)}><Save size={14} aria-hidden="true"/>{tr(" Сохранить")}</button>
                            <button className={styles.btn_pin_close} style={{ marginLeft: 8 }} onClick={() => cancelEdit('privatepoint', pp.id)}><X size={14} aria-hidden="true"/>{tr(" Отмена")}</button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {tr(expandedPrivatePoint === pp.id && (
                    <tr>
                      <td colSpan={5}>
                        <div className={styles.operatorsList}>
                          {tr(expandedBranchesPrivatePoint === pp.id && (
                            <BranchesList
                              base={pp}
                              baseType="privatepoint"
                              branches={branchesByPrivatePoint[pp.id] || []}
                              branchesFilter={branchesFilterByPrivatePoint[pp.id]}
                              setBranchesFilter={(v) => setBranchesFilterByPrivatePoint(prev => ({ ...prev, [pp.id]: v }))}
                              loadBranchesByBasePage={loadBranchesByPrivatePointPage}
                              openCreateModal={openCreateModal}
                              editingBranch={editingBranchByPrivatePoint}
                              editPayloads={editPayloads}
                              setEditPayloads={setEditPayloads}
                              startEdit={startEditBranch}
                              saveEdit={saveEditBranch}
                              cancelEdit={cancelEditBranch}
                              branchesPagination={branchesPaginationByPrivatePoint[pp.id] || {}}
                            />
                          ))}

                          {tr(expandedOperatorsPrivatePoint === pp.id && (
                            <OperatorsForPrivatePoint
                              pp={pp}
                              operators={operatorsByPrivatePoint[pp.id]}
                              operatorsFilter={operatorsFilterByPrivatePoint[pp.id]}
                              setOperatorsFilter={(v) => setOperatorsFilterByPrivatePoint(prev => ({ ...prev, [pp.id]: v }))}
                              loadOperatorsByPrivatePointPage={loadOperatorsByPrivatePointPage}
                              employees={employees}
                              openCreateModal={openCreateModal}
                              editingOperatorByPrivatePoint={editingOperatorByPrivatePoint}
                              editPayloads={editPayloads}
                              setEditPayloads={setEditPayloads}
                              startEdit={startEditOperator}
                              saveEdit={saveEditOperator}
                              cancelEdit={cancelEditOperator}
                              operatorsPagination={operatorsPaginationByPrivatePoint[pp.id]}
                              expandedOperatorByPrivatePoint={expandedOperatorByPrivatePoint}
                              toggleOperator={toggleOperatorPrivatePoint}
                            />
                          ))}

                          {tr(driversVisible && expandedDriversPrivatePoint === pp.id && (
                            <DriversForPrivatePoint
                              pp={pp}
                              drivers={driversByPrivatePoint[pp.id]}
                              driversFilter={driversFilterByPrivatePoint[pp.id]}
                              setDriversFilter={(v) => setDriversFilterByPrivatePoint(prev => ({ ...prev, [pp.id]: v }))}
                              loadDriversByPrivatePointPage={loadDriversByPrivatePointPage}
                              employees={employees}
                              editingDriverByPrivatePoint={editingDriverByPrivatePoint}
                              editPayloads={editPayloads}
                              setEditPayloads={setEditPayloads}
                              startEdit={startEditDriver}
                              saveEdit={saveEditDriver}
                              openCreateModal={openCreateModal}
                              cancelEdit={cancelEditDriver}
                              driversPagination={driversPaginationByPrivatePoint[pp.id]}
                              expandedDriverByPrivatePoint={expandedDriverByPrivatePoint}
                              toggleDriver={toggleDriver}
                              printDriverPass={printDriverPass}
                              downloadDriverPass={downloadDriverPass}
                              privatePoints={privatePoints}
                              topBases={topBases}
                              chpps={chpps}
                            />
                          ))}
                        </div>
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </ResponsiveTable>
        ) : (
          <EmptyState icon={Building2} title={tr("Социальные объекты не найдены")} description={tr("Добавьте объект или измените условия поиска.")} compact />
        )}
        {tr((!privatePointsFilter && privatePointsPagination && privatePointsPagination.count > 0) && (
          <div className={styles.pagination}>
            <button disabled={!privatePointsPagination.previous} onClick={() => loadPrivatePointsPage((privatePointsPagination.page || 1) - 1)}><ChevronLeft size={14} aria-hidden="true"/>{tr(" Пред.")}</button>
            <span>{tr("Стр. ")}{tr(privatePointsPagination.page || 1)}{tr(" — Всего: ")}{tr(privatePointsPagination.count)}</span>
            <button disabled={!privatePointsPagination.next} onClick={() => loadPrivatePointsPage((privatePointsPagination.page || 1) + 1)}><ChevronRight size={14} aria-hidden="true"/>{tr(" След.")}</button>
          </div>
        ))}
      </div>
    </div>
  )
}

// Inline components for operators and drivers
const OperatorsForPrivatePoint = ({ pp, operators = [], operatorsFilter = '', setOperatorsFilter = () => {}, openCreateModal, loadOperatorsByPrivatePointPage = () => {}, employees = [], editingOperatorByPrivatePoint = {}, editPayloads = {}, setEditPayloads = () => {}, startEdit = () => {}, saveEdit = () => {}, cancelEdit = () => {}, operatorsPagination = {}, expandedOperatorByPrivatePoint = {}, toggleOperator = () => {} }) => { useInterfaceLanguage(); return (<div style={{ marginTop: 12 }}>
    <div className={styles.subsectionHeader} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <strong className={styles.subsectionTitle}><UsersRound size={17} aria-hidden="true"/>{tr(" Операторы объекта / МСУ")}</strong>
      <div>
        <button className={`${styles.smallBtn} ${styles.addButton}`} onClick={() => openCreateModal('privatepoint-operator', { private_point: pp.id, private_point_name: pp.name })}><Plus size={14} aria-hidden="true"/>{tr(" Добавить оператора")}</button>
      </div>
    </div>
    <div style={{ marginTop: 8 }}>
      <div className={styles.searchRow}>
        <input className={styles.searchInput} placeholder={tr("Поиск...")} value={operatorsFilter || ''} onChange={(e) => setOperatorsFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadOperatorsByPrivatePointPage(pp.id, 1, operatorsFilter || '') }} />
      </div>
      {(operators && operators.length) ? (
        <>
          <ResponsiveTable className={styles.table}>
            <thead>
              <tr>
                <th>№</th>
                <th>{tr("Сотрудник")}</th>
                <th>{tr("Номер телефона")}</th>
                <th>{tr("Дополнительный ном.тел")}</th>
                <th>{tr("Создано")}</th>
                <th>{tr("Статус")}</th>
                <th>{tr("Действия")}</th>
              </tr>
            </thead>
            <tbody>
              {operators.map((op, idx) => {
                const q = (operatorsFilter || '').toLowerCase()
                if (q) {
                  const emp = op.employee_name || String(op.employee)
                  if (!((emp && emp.toLowerCase().includes(q)) || (op.phone && String(op.phone).toLowerCase().includes(q)))) {
                    return null
                  }
                }
                return (
                  <React.Fragment key={op.id}>
                    <tr style={{ cursor: 'pointer' }} onClick={() => toggleOperator(pp.id, op.id)}>
                      <td>{tr(idx + 1)}</td>
                      <td>{tr(op.employee_name || op.employee)}</td>
                      <td>{tr(op.employee_phone || '-')}</td>
                      <td>{tr(op.phone || '-')}</td>
                      <td><DateTime value={op.created_at}/></td>
                      <td><StatusBadge tone={op.is_active ? 'success' : 'danger'}>{op.is_active ? tr("Активен") : tr("Неактивен")}</StatusBadge></td>
                      <td>
                        <div className={styles.actionGroup}>
                          <button className={`${styles.smallBtn} ${styles.editBtn}`} onClick={(ev) => { ev.stopPropagation(); startEdit('privatepoint-operator', { private_point: pp.id, opId: op.id }, { phone: op.phone, is_active: op.is_active, employee: op.employee }) }}><Pencil size={14} aria-hidden="true"/>{tr(" Изменить")}</button><OperatorPinResetAction operator={op} onChanged={() => loadOperatorsByPrivatePointPage(pp.id, operatorsPagination.page || 1, operatorsFilter)} /><OperatorInnChangeAction operator={op} onChanged={() => loadOperatorsByPrivatePointPage(pp.id, operatorsPagination.page || 1, operatorsFilter)} /><AuditButton section="private_points" objectId={op.id} objectType="tabel.TopBaseOperator"/>
                        </div>
                      </td>
                    </tr>
                    {tr(expandedOperatorByPrivatePoint[pp.id] === op.id && (
                      <tr>
                        <td colSpan={7} style={{ textAlign: 'start', padding: 12 }}>
                          <div style={{ display: 'inline-block', position: 'relative', textAlign: 'left', width: '100%' }}>
                            <div style={{ marginTop: 16, borderTop: "1px solid var(--theme-border, #e0e0e0)", paddingTop: 12 }}>
                              <strong>{tr("Документы оператора:")}</strong>
                              {op.documents && op.documents.length > 0 ? (
                                <ul style={{ marginTop: 8, paddingLeft: 20 }}>
                                  {op.documents.map(doc => (
                                    <li key={doc.id} style={{ marginBottom: 8 }}>
                                      <a href={doc.file_url} target="_blank" rel="noopener noreferrer" style={{ color: "var(--theme-primary-text, #0d00f3)", textDecoration: 'none' }}>
                                        {tr(doc.file_name)}
                                      </a>
                                      <span style={{ marginLeft: 8, color: "var(--theme-text-muted, #666)", fontSize: '12px' }}>
                                        ({(doc.file_size / 1024).toFixed(1)}{tr(" КБ) - ")}{new Date(doc.uploaded_at).toLocaleString(getLocale())}
                                      </span>
                                    </li>
                                  ))}
                                </ul>
                              ) : (
                                <div style={{ marginTop: 8, color: "var(--theme-text-muted, #666)", fontStyle: 'italic' }}><EmptyState icon={FileText} title={tr("Нет документов")} compact /></div>
                              )}
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                    {tr(editingOperatorByPrivatePoint[pp.id] === op.id && (
                      <tr>
                        <td colSpan={7}>
                          <div style={{ padding: 8 }}>
                            <label>{tr("Сотрудник")}</label>
                            <select value={(editPayloads[`privatepoint-operator_${pp.id}_${op.id}`] || {}).employee || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`privatepoint-operator_${pp.id}_${op.id}`]: { ...p[`privatepoint-operator_${pp.id}_${op.id}`], employee: Number(e.target.value) } }))}>
                              <option value="">{tr("— Выберите сотрудника —")}</option>
                              {employees.map(emp => (<option key={emp.id} value={emp.id}>{tr(emp.label)}</option>))}
                            </select>
                            <label style={{ marginLeft: 8 }}>{tr("Телефон")}</label>
                            <input value={(editPayloads[`privatepoint-operator_${pp.id}_${op.id}`] || {}).phone || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`privatepoint-operator_${pp.id}_${op.id}`]: { ...p[`privatepoint-operator_${pp.id}_${op.id}`], phone: e.target.value } }))} />
                            <label style={{ marginLeft: 8 }}>{tr("Активен")}</label>
                            <input type="checkbox" checked={(editPayloads[`privatepoint-operator_${pp.id}_${op.id}`] || {}).is_active || false} onChange={(e) => setEditPayloads(p => ({ ...p, [`privatepoint-operator_${pp.id}_${op.id}`]: { ...p[`privatepoint-operator_${pp.id}_${op.id}`], is_active: e.target.checked } }))} />

                            <div style={{ marginTop: 8 }}>
                              <label>{tr("Документы")}</label>
                              <LocalizedFileInput
                                type="file"
                                multiple
                                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.webp"
                                onChange={(e) => {
                                  const files = Array.from(e.target.files || [])
                                  setEditPayloads(p => ({
                                    ...p,
                                    [`privatepoint-operator_${pp.id}_${op.id}`]: {
                                      ...p[`privatepoint-operator_${pp.id}_${op.id}`],
                                      newDocuments: files
                                    }
                                  }))
                                }}
                              />
                              {tr(op.documents && op.documents.length > 0 && (
                                <div style={{ marginTop: 4, fontSize: '0.9em' }}>
                                  <strong>{tr("Текущие документы:")}</strong>
                                  <ul style={{ margin: '4px 0', paddingLeft: 20 }}>
                                    {op.documents.map(doc => (
                                      <li key={doc.id}>
                                        <a href={doc.file_url} target="_blank" rel="noopener noreferrer">
                                          {tr(doc.file_name)}
                                        </a>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                              ))}
                            </div>

                            <div style={{ marginTop: 8 }}>
                              <button className={styles.btn_pin} onClick={() => saveEdit('privatepoint-operator', { private_point: pp.id, opId: op.id })}><Save size={14} aria-hidden="true"/>{tr(" Сохранить")}</button>
                              <button className={styles.btn_pin_close} style={{ marginLeft: 8 }} onClick={() => cancelEdit('privatepoint-operator', { private_point: pp.id })}><X size={14} aria-hidden="true"/>{tr(" Отмена")}</button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </React.Fragment>
                )
              })}
            </tbody>
          </ResponsiveTable>
          {tr((!operatorsFilter && operatorsPagination && operatorsPagination.count > 0) && (
            <div className={styles.pagination}>
              <button disabled={!operatorsPagination.previous} onClick={() => loadOperatorsByPrivatePointPage(pp.id, (operatorsPagination.page || 1) - 1)}><ChevronLeft size={14} aria-hidden="true"/>{tr(" Пред.")}</button>
              <span>{tr("Стр. ")}{tr(operatorsPagination.page || 1)}{tr(" — Всего: ")}{tr(operatorsPagination.count)}</span>
              <button disabled={!operatorsPagination.next} onClick={() => loadOperatorsByPrivatePointPage(pp.id, (operatorsPagination.page || 1) + 1)}><ChevronRight size={14} aria-hidden="true"/>{tr(" След.")}</button>
            </div>
          ))}
        </>
      ) : (
        <div><EmptyState icon={UsersRound} title={tr("Операторы не найдены")} compact /></div>
      )}
    </div>
  </div>); }

const DriversForPrivatePoint = ({ pp, drivers = [], driversFilter = '', setDriversFilter = () => {}, openCreateModal, loadDriversByPrivatePointPage = () => {}, employees = [], editingDriverByPrivatePoint = {}, editPayloads = {}, setEditPayloads = () => {}, startEdit = () => {}, saveEdit = () => {}, cancelEdit = () => {}, driversPagination = {}, expandedDriverByPrivatePoint = {}, toggleDriver = () => {}, printDriverPass = () => {}, downloadDriverPass = () => {}, privatePoints = [], topBases = [], chpps = [] }) => {
  useInterfaceLanguage();
  const user=useSelector(state=>state.user)
  return (
  <div style={{ marginTop: 12 }}>
    <div className={styles.subsectionHeader} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <strong className={styles.subsectionTitle}><Truck size={17} aria-hidden="true"/>{tr(" Водители объекта / МСУ")}</strong>{tr(hasAccess(user,'drivers_edit') && <NavLink className={`${styles.smallBtn} ${styles.addButton}`} to={'/driver-register-admin/?destination=private_point:' + pp.id}><Plus size={14} aria-hidden="true"/>{tr(" Регистрация водителя")}</NavLink>)}
      <div>
        {tr(hasAccess(user,'drivers_edit') && <button className={`${styles.smallBtn} ${styles.addButton}`} onClick={() => openCreateModal('privatepoint-driver', { private_point: pp.id, private_point_name: pp.name })}><Plus size={14} aria-hidden="true"/>{tr(" Добавить водителя")}</button>)}
      </div>
    </div>
    <div style={{ marginTop: 8 }}>
      <div className={styles.searchRow}>
        <input className={styles.searchInput} placeholder={tr("Поиск...")} value={driversFilter || ''} onChange={(e) => setDriversFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadDriversByPrivatePointPage(pp.id, 1, driversFilter || '') }} />
      </div>
      {(drivers && drivers.length) ? (
        <>
          <ResponsiveTable className={`${styles.table} ${list.table}`}>
            <thead>
              <tr>{BASE_DRIVER_COLUMNS.map(label => <th key={label}>{tr(label)}</th>)}</tr>
            </thead>
            <tbody>
              {drivers.map(d => (
                <React.Fragment key={d.id}>
                  <BaseDriverSummary driver={d} expanded={expandedDriverByPrivatePoint[pp.id] === d.id}
                    editing={editingDriverByPrivatePoint?.[pp.id] === d.id} detailId={`base-driver-private_point-${pp.id}-${d.id}`}
                    onToggle={() => toggleDriver(pp.id, d.id)}
                    onEdit={hasAccess(user, 'drivers_edit') ? () => startEdit('privatepoint-driver', { private_point: pp.id, drId: d.id }, { employee: d.employee, private_point: d.private_point || pp.id, vehicle_number: d.vehicle_number, vehicle_model: d.vehicle_model, phone: d.phone, is_active: d.is_active, pass_expiry_days: d.pass_expiry_days, pass_loads_limit: d.pass_loads_limit }) : undefined} />
                  {tr(expandedDriverByPrivatePoint[pp.id] === d.id && (
                    <tr>
                      <td colSpan={6}>
                        <div id={`base-driver-private_point-${pp.id}-${d.id}`} className={list.expanded}>
                          <DriverActions driver={d} edit={false} onChanged={() => loadDriversByPrivatePointPage(pp.id, driversPagination.page || 1, driversFilter)} />
                          <BaseDriverDetails driver={d} privatePoint
                            onPrint={() => printDriverPass(d, tr("Социальные объекты / МСУ"), privatePoints.find(x => String(x.id) === String(d.private_point))?.name || pp.name || '')}
                            onDownload={() => downloadDriverPass(d, tr("Социальные объекты / МСУ"), privatePoints.find(x => String(x.id) === String(d.private_point))?.name || pp.name || '')} />
                        </div>
                      </td>
                    </tr>
                  ))}
                  {tr(editingDriverByPrivatePoint[pp.id] === d.id && (
                    <tr>
                      <td colSpan={6}>
                        <div style={{ padding: 8 }}>
                          <p>{tr("Водитель")}: {tr(d.employee_name || "Без водителя")}</p>
                            <p>{tr("База")}: {tr(d.top_base_name || "Без базы")}</p>
                            <label style={{ marginLeft: 8 }}>{tr("Номер машины")}</label>
                          <VehicleNumberInput value={(editPayloads[`privatepoint-driver_${pp.id}_${d.id}`] || {}).vehicle_number || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`privatepoint-driver_${pp.id}_${d.id}`]: { ...p[`privatepoint-driver_${pp.id}_${d.id}`], vehicle_number: e.target.value } }))} />
                          <label style={{ marginLeft: 8 }}>{tr("Модель")}</label>
                          <input value={(editPayloads[`privatepoint-driver_${pp.id}_${d.id}`] || {}).vehicle_model || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`privatepoint-driver_${pp.id}_${d.id}`]: { ...p[`privatepoint-driver_${pp.id}_${d.id}`], vehicle_model: e.target.value } }))} />
                          <label style={{ marginLeft: 8 }}>{tr("Телефон")}</label>
                          <input value={(editPayloads[`privatepoint-driver_${pp.id}_${d.id}`] || {}).phone || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`privatepoint-driver_${pp.id}_${d.id}`]: { ...p[`privatepoint-driver_${pp.id}_${d.id}`], phone: e.target.value } }))} />
                          <label style={{ marginLeft: 8 }}>{tr("Срок (дней)")}</label>
                          <input type="number" value={(editPayloads[`privatepoint-driver_${pp.id}_${d.id}`] || {}).pass_expiry_days || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`privatepoint-driver_${pp.id}_${d.id}`]: { ...p[`privatepoint-driver_${pp.id}_${d.id}`], pass_expiry_days: Number(e.target.value) } }))} />
                          <label style={{ marginLeft: 8 }}>{tr("Лимит погрузок")}</label>
                          <input type="number" value={(editPayloads[`privatepoint-driver_${pp.id}_${d.id}`] || {}).pass_loads_limit || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`privatepoint-driver_${pp.id}_${d.id}`]: { ...p[`privatepoint-driver_${pp.id}_${d.id}`], pass_loads_limit: Number(e.target.value) } }))} />
                          <label style={{ marginLeft: 8 }}>{tr("Активен")}</label>
                          <input type="checkbox" disabled={!hasAccess(user,'drivers_active')} aria-label={tr("Активность водителя")} checked={(editPayloads[`privatepoint-driver_${pp.id}_${d.id}`] || {}).is_active || false} onChange={(e) => setEditPayloads(p => ({ ...p, [`privatepoint-driver_${pp.id}_${d.id}`]: { ...p[`privatepoint-driver_${pp.id}_${d.id}`], is_active: e.target.checked, actor_pin: '' } }))} />
                          {hasAccess(user, 'drivers_active') && !!(editPayloads[`privatepoint-driver_${pp.id}_${d.id}`] || {}).is_active !== !!d.is_active && (
                            <ActorPinField value={(editPayloads[`privatepoint-driver_${pp.id}_${d.id}`] || {}).actor_pin || ''}
                              onChange={pin => setEditPayloads(p => ({ ...p, [`privatepoint-driver_${pp.id}_${d.id}`]: { ...p[`privatepoint-driver_${pp.id}_${d.id}`], actor_pin: pin } }))} />
                          )}

                          <div style={{ marginTop: 8 }}>
                            <label>{tr("Документы")}</label>
                            <LocalizedFileInput
                              type="file"
                              multiple
                              accept=".pdf,.doc,.docx,.jpg,.jpeg,.png,.webp"
                              onChange={(e) => {
                                const files = Array.from(e.target.files || [])
                                setEditPayloads(p => ({
                                  ...p,
                                  [`privatepoint-driver_${pp.id}_${d.id}`]: {
                                    ...p[`privatepoint-driver_${pp.id}_${d.id}`],
                                    newDocuments: files
                                  }
                                }))
                              }}
                            />
                            {tr(d.documents && d.documents.length > 0 && (
                              <div style={{ marginTop: 4, fontSize: '0.9em' }}>
                                <strong>{tr("Текущие документы:")}</strong>
                                <ul style={{ margin: '4px 0', paddingLeft: 20 }}>
                                  {d.documents.map(doc => (
                                    <li key={doc.id}>
                                      <a href={doc.file_url} target="_blank" rel="noopener noreferrer">
                                        {tr(doc.file_name)}
                                      </a>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            ))}
                          </div>

                          <div style={{ marginTop: 8 }}>
                            <button className={styles.btn_pin} disabled={!!(editPayloads[`privatepoint-driver_${pp.id}_${d.id}`] || {}).is_active !== !!d.is_active && !/^[0-9]{4}$/.test((editPayloads[`privatepoint-driver_${pp.id}_${d.id}`] || {}).actor_pin || '')} onClick={() => saveEdit('privatepoint-driver', { private_point: pp.id, drId: d.id })}><Save size={14} aria-hidden="true"/>{tr(" Сохранить")}</button>
                            <button className={styles.btn_pin_close} style={{ marginLeft: 8 }} onClick={() => cancelEdit('privatepoint-driver', { private_point: pp.id })}><X size={14} aria-hidden="true"/>{tr(" Отмена")}</button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </ResponsiveTable>
          {tr((driversPagination && driversPagination.count > 0) && (
            <div className={styles.pagination}>
              <button disabled={!driversPagination.previous} onClick={() => loadDriversByPrivatePointPage(pp.id, (driversPagination.page || 1) - 1, driversFilter)}><ChevronLeft size={14} aria-hidden="true"/>{tr(" Пред.")}</button>
              <span>{tr("Стр. ")}{tr(driversPagination.page || 1)}{tr(" из ")}{Math.ceil(driversPagination.count / 25)}{tr(" — Всего: ")}{tr(driversPagination.count)}</span>
              <button disabled={!driversPagination.next} onClick={() => loadDriversByPrivatePointPage(pp.id, (driversPagination.page || 1) + 1, driversFilter)}><ChevronRight size={14} aria-hidden="true"/>{tr(" След.")}</button>
            </div>
          ))}
        </>
      ) : (
        <div><EmptyState icon={Truck} title={tr("Водители на этой базе не найдены")} compact /></div>
      )}
    </div>
  </div>
)
}

export default PrivatePointsPanel
